import React, { useReducer, useState } from "react";
import RollbarErrorTracking from "./utils/RollbarErrorTracking";

function  HandleError(err: any) {
    const [toastOptions, setToastOptions] = useReducer((state: any, newState: any) => ({ ...state, ...newState }), {
        toastOpen: false,
        toastSeverity: "error",
        toastMessageKey: "",
      });
    
      const handleToastOptionsDirect = (name: string, val: any) => {
        setToastOptions({ [name]: val });
      }

      const toasterHandle = (open: boolean, severity: string, messageKey: string) => {
        handleToastOptionsDirect("toastSeverity", severity);
        handleToastOptionsDirect("toastMessageKey", messageKey);
        handleToastOptionsDirect("toastOpen", !!open);
      };
      toasterHandle(true, "error", "message_errorDefault");
      RollbarErrorTracking.logErrorInRollbar(err.message, "error");
}

export default HandleError;